import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { HEADER_LOGO_URL } from '../../config/cloudinaryBrandImages';
import { BLOG_HERO_VIDEO } from '../../media/blogHeroMedia';
import { preloadBlogDetailHero } from '../../utils/blogVideoCache';

/** Injects `<link rel="preload">` for above-the-fold assets once React boots. */
export default function CriticalPreloads() {
  const { pathname } = useLocation();
  const onBlogListing = pathname === '/blog' || pathname === '/blog-page';
  const blogDetailId = pathname.match(/^\/(?:blog-detail|blog)\/(\d+)/)?.[1] ?? null;

  useEffect(() => {
    if (!blogDetailId) return;
    import('../blog/blogPostsData')
      .then((mod) => {
        const post = mod.BLOG_POSTS_BY_ID[blogDetailId];
        if (post?.image) preloadBlogDetailHero(post.image, { warm: true });
      })
      .catch(() => {});
  }, [blogDetailId]);

  return (
    <Helmet>
      <link rel="preload" as="image" href={HEADER_LOGO_URL} type="image/svg+xml" crossOrigin="anonymous" />
      {onBlogListing ? (
        <link rel="preload" as="video" href={BLOG_HERO_VIDEO} type="video/mp4" />
      ) : null}
    </Helmet>
  );
}
